export default __webpack_public_path__ + "static/media/featured-music.f0d9e770.png";